<template>
  <div>
    <div class="relative flex w-full flex-col gap-0.5">
      <div
        v-for="row in filledRows.length"
        :key="row"
        class="flex w-full flex-nowrap justify-center gap-0.5"
      >
        <WordleMiniBoardCell
          v-for="(cell, cellIndex) in filledRows[row - 1]"
          :key="'cell-' + cellIndex"
          :letter="cell"
          :hidden="hideLetters"
          :index="cellIndex"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import WordleMiniBoardCell from "@/components/wordle/WordleMiniBoardCell.vue";
import { computed } from "vue";
import type { WordleGameState } from "@kekkle/shared/types/fields/wordle-game-state/wordle-game-state";

type Props = {
  gameState: WordleGameState;
  hideLetters?: boolean;
};

const props = defineProps<Props>();

const filledRows = computed(() => {
  return props.gameState.filter((row) => {
    return row.every((cell) => cell.character !== "");
  });
});
</script>
